module.exports = __webpack_public_path__ + "static/media/duffel.d35ca784.svg";